<template>
  <div class="exam-scale-wrapper">
  <el-container class="page">
    <!-- 顶部导航栏 -->
    <el-header class="page-header">
      <div class="header-content">
        <span class="header-title">{{ $route.params.type === 'nature' ? '性格测试' : '智能考试系统' }}</span>
        <el-tag
          :type="remainingSeconds <= 300 ? 'danger' : (remainingSeconds <= 600 ? 'warning' : 'success')"
          class="countdown-tag"
        >
          倒计时：{{ countdown }}
        </el-tag>
      </div>
    </el-header>

    <!-- 主内容区域 -->
    <el-container class="main-container">
      <!-- 左侧栏 -->
      <el-aside width="430px" class="left-aside">
        <!-- 实时监控卡片 -->
        <el-card class="monitor-card" shadow="never">
          <div slot="header" class="card-header">
            <span class="card-title">实时监控</span>
            <el-tag type="success" size="small">监控中</el-tag>
              </div>
          <div class="monitor-content">
            <video
              ref="videoElement"
              class="monitor-video"
              autoplay
              playsinline
              muted
            ></video>
            <div v-if="!cameraEnabled" class="camera-placeholder">
              <i class="el-icon-video-camera"></i>
              <p>摄像头未启用</p>
            </div>
          </div>
        </el-card>

        <!-- 考试须知卡片 -->
        <el-card class="notice-card" shadow="never">
          <div slot="header" class="card-header">
            <i class="el-icon-info"></i>
            <span class="card-title">考试须知</span>
              </div>
          <!-- <el-divider></el-divider> -->
          <div class="notice-list">
            <div class="notice-item">

              <div class="notice-text">
                <div><i class="el-icon-warning"></i> 请端正坐姿，并确保面部在摄像头区域内</div>
                <div><i class="el-icon-warning"></i> 不要离开摄像头视野</div>
                <div><i class="el-icon-warning"></i> 请勿切屏、截屏或使用其他电子设备</div>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 答题进度卡片 -->
        <el-card class="progress-card" shadow="never">
          <!-- <div slot="header" class="card-header">
            <span class="card-title">答题进度</span>
          </div> -->
          <!-- <el-divider></el-divider> -->
          <div class="progress-content">
            <div class="progress-label">完成度</div>
            <div class="progress-bar-wrapper">
              <el-progress
                :percentage="progressPercentage"
                :color="progressColor"
                :stroke-width="11"
                :show-text="false"
              ></el-progress>
              <span class="progress-text">{{ progressPercentage }}%</span>
            </div>
            <div class="question-numbers">
              <div class="question-row" v-for="(row, rowIndex) in questionRows" :key="rowIndex">
                <el-tag
                  v-for="num in row"
                  style="width: 17%;"
                  :key="num"
                  :type="getQuestionTagType(num)"
                  :class="['question-tag', { 'active': currentQuestionIndex === num - 1 }]"
                  @click="handleQuestionClick(num)"
                >
                  {{ num }}
                </el-tag>
              </div>
            </div>
          </div>
        </el-card>

        <!-- 提交试卷按钮 -->
        <el-button
          type="primary"
          class="submit-btn"
          @click="handleSubmit"
        >
          提交试卷
        </el-button>
      </el-aside>

      <!-- 右侧答题区域 -->
      <el-main class="right-main">
        <el-card class="answer-card" shadow="never" v-loading="loading">
          <div class="answer-content" v-if="!loading && questionList.length > 0">
            <h2 class="question-title">
              <span class="question-type" style="background-color:#eee;">{{ questionTypeText }}</span>
              {{ currentQuestion.title }}
            </h2>
            <!-- 简答题 -->
            <template v-if="currentQuestion.type === 1">
              <el-input
                v-model="currentAnswer"
                type="textarea"
                :rows="10"
                maxlength="2000"
                placeholder="请输入您的答案"
                class="answer-input"
              />

            </template>
            <!-- 单选题 -->
            <el-radio-group
              v-else-if="currentQuestion.type === 2"
              v-model="currentAnswer"
              class="choice-options"
            >
              <el-radio
                v-for="(option, index) in currentQuestionOptions"
                :key="index"
                :label="option.value"
                class="choice-option"
              >
                <span class="option-label">{{ option.label }}：</span>
                <span class="option-content">{{ option.content }}</span>
              </el-radio>
            </el-radio-group>
            <!-- 多选题 -->
            <el-checkbox-group
              v-else-if="currentQuestion.type === 3"
              v-model="currentAnswer"
              class="choice-options"
            >
              <el-checkbox
                v-for="(option, index) in currentQuestionOptions"
                :key="index"
                :label="option.value"
                class="choice-option"
              >
                <span class="option-label">{{ option.label }}：</span>
                <span class="option-content">{{ option.content }}</span>
              </el-checkbox>
            </el-checkbox-group>
            <!-- 判断题 -->
            <el-radio-group
              v-else-if="currentQuestion.type === 4"
              v-model="currentAnswer"
              class="choice-options"
            >
              <el-radio
                v-for="(option, index) in currentQuestionOptions"
                :key="index"
                :label="option.value"
                class="choice-option"
              >
                <span class="option-label">{{ option.label }}：</span>
                <span class="option-content">{{ option.content }}</span>
              </el-radio>
            </el-radio-group>
            <div class="answer-footer">
              <span class="word-count"></span>
              <div class="action-buttons">
                <el-button
                  :disabled="currentQuestionIndex === 0 || !questionList || questionList.length === 0"
                  @click="handlePrevQuestion"
                >
                  上一题
                </el-button>
                <el-button
                  type="primary"
                  :style="{ backgroundColor: (!questionList || questionList.length === 0 || currentQuestionIndex === questionList.length - 1) ? '#C0C4CC' : '#3695F0' }"
                  :disabled="!questionList || questionList.length === 0 || currentQuestionIndex === questionList.length - 1"
                  @click="handleNextQuestion"
                >
                  下一题
                </el-button>
              </div>
            </div>
          </div>
          <div v-else-if="!loading && questionList.length === 0" class="empty-tip">
            <p>暂无题目数据</p>
        </div>
        </el-card>
      </el-main>
    </el-container>

    <!-- 性格测试完成弹窗 -->
    <el-dialog
      :visible.sync="natureCompleteDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :append-to-body="true"
      :z-index="10000"
      width="400px"
      center
    >
      <div class="nature-complete-dialog-content" style="text-align: center; padding: 20px 0;">
        <i class="el-icon-success" style="font-size: 48px; color: #67c23a; margin-bottom: 20px;"></i>
        <h3 style="margin: 0 0 10px 0; font-size: 20px; color: #333;">测试完成</h3>
        <p style="margin: 0; font-size: 16px; color: #666;">{{ natureCompleteCountdown }}秒后跳转到首页</p>
      </div>
    </el-dialog>

    <!-- 判卷中弹窗（append-to-body 避免被 scale 父级层叠上下文挡住） -->
    <el-dialog
      :visible.sync="gradingDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :append-to-body="true"
      :z-index="10000"
      width="400px"
      center
    >
      <div class="grading-dialog-content">
        <i class="el-icon-loading" style="font-size: 48px; color: #409eff; margin-bottom: 20px;"></i>
        <h3 style="margin: 0 0 10px 0; font-size: 20px; color: #333;">判卷中，请等待</h3>
<!--        <p style="margin: 0; font-size: 16px; color: #666;">{{ gradingCountdown }} ...</p>-->
      </div>
    </el-dialog>

    <!-- 正式考试结果弹窗（append-to-body 避免被 scale 父级层叠上下文挡住） -->
    <el-dialog
      :visible.sync="resultDialogVisible"
      title="本次答题情况"
      width="560px"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      class="result-dialog"
      @close="handleResultDialogClose"
    >
      <div class="result-dialog-body">
        <div class="result-dialog-header">
          <span class="result-job-title">{{ resultDialogData.jobTitle }}</span>
        </div>
        <div class="result-status-bar">
          <div class="result-status-item">
            <i class="el-icon-success result-status-icon score-icon"></i>
            <span class="result-status-value">{{ resultDialogData.score }}</span>
            <span class="result-status-label">得分</span>
          </div>
          <div class="result-status-item">
            <i class="el-icon-error result-status-icon error-icon"></i>
            <span class="result-status-value">{{ resultDialogData.correctCount }}/{{ resultDialogData.totalCount }}</span>
            <span class="result-status-label">答对题目数</span>
          </div>
          <div class="result-status-item">
            <i class="el-icon-time result-status-icon time-icon"></i>
            <span class="result-status-value">{{ resultDialogData.timeSpent }}</span>
            <span class="result-status-label">用时</span>
          </div>
        </div>
        <div class="result-dialog-message" :class="resultDialogData.score >= 85 ? 'pass' : 'fail'">
          <template v-if="resultDialogData.score >= 85">恭喜你，笔试通过！</template>
          <template v-else>笔试未通过，请再接再厉</template>
        </div>
        <div class="result-dialog-footer">
          <el-button type="primary" @click="handleBackToIndex">返回首页</el-button>
        </div>
      </div>
    </el-dialog>
  </el-container>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getAccessToken } from '@/utils/auth'

export default {
  name: 'ExamPage',
  data() {
    return {
      countdown: '',
      remainingSeconds: 5400, // 90分钟 = 5400秒
      countdownTimer: null,
      currentQuestionIndex: 0,
      currentAnswer: '',
      progressPercentage: 0,
      progressColor: '#1b9b71',
      questionList: [],
      loading: false,
      questionRows: [],
      examStartTime: null, // 考试开始时间
      examKey: 'exam_data_' + Date.now(), // 考试唯一标识
      cameraEnabled: false, // 摄像头是否启用
      mediaStream: null, // 视频流对象
      examId: null, // 考试ID
      gradingCountdown: 10, // 判卷倒计时（秒）
      gradingTimer: null, // 判卷倒计时定时器
      gradingDialogVisible: false, // 判卷弹窗显示状态
      isFormalGrading: false, // 当前是否为正式考试判卷（正式考后弹窗结果，模拟考后跳转结果页）
      resultDialogVisible: false, // 正式考试结果弹窗
      resultDialogData: {
        jobTitle: 'UI工程师',
        score: 0,
        correctCount: 0,
        totalCount: 0,
        timeSpent: '0分钟'
      },
      examSubmitted: false, // 是否已提交试卷（提交后不再保存到缓存，并在销毁时移除缓存）
      natureCompleteDialogVisible: false, // 性格测试完成弹窗
      natureCompleteCountdown: 3, // 性格测试完成倒计时
      natureCompleteTimer: null // 性格测试完成定时器
    };
  },
  computed: {
    totalQuestions() {
      return this.questionList.length;
    },
    currentQuestion() {
      return this.questionList[this.currentQuestionIndex] || {};
    },
    // 解析选择题选项（单选、多选和判断题共用）
    currentQuestionOptions() {
      // 判断题：固定返回正确/错误两个选项
      if (this.currentQuestion.type === 4) {
        return [
          { label: 'A', value: 'A', content: '正确' },
          { label: 'B', value: 'B', content: '错误' }
        ];
      }

      // 选择题（单选和多选）：解析答案格式
      if ((this.currentQuestion.type !== 2 && this.currentQuestion.type !== 3) || !this.currentQuestion.content) {
        return [];
      }

      // 解析答案格式：A:内容1,B:内容2,C:内容3,D:内容4（内容中可含逗号，故在「,字母:」处分割）
      const contentStr = this.currentQuestion.content;
      const options = [];
      // 在「逗号+大写字母+冒号」处分割，避免选项内容里的逗号（如代码 "A,B,D"）被误分割
      const parts = contentStr.split(/,(?=[A-Z]:)/);

      parts.forEach(part => {
        const match = part.match(/^([A-Z]):([\s\S]+)$/);
        if (match) {
          options.push({
            label: match[1],
            value: match[1],
            content: match[2].trim()
          });
        }
      });

      return options;
    },
    // 已答题目的编号
    answeredQuestions() {
      return this.questionList
        .map((q, index) => {
          if (q.userAnswer !== undefined && q.userAnswer !== null && q.userAnswer !== '') {
            if (q.type === 3 && Array.isArray(q.userAnswer)) {
              return q.userAnswer.length > 0 ? index + 1 : null;
            }
            return index + 1;
          }
          return null;
        })
        .filter(num => num !== null);
    },
    // 获取题型文本
    questionTypeText() {
      const typeMap = {
        1: '简答题',
        2: '单选题',
        3: '多选题',
        4: '判断题'
      };
      return typeMap[this.currentQuestion.type] || '';
    }
  },
  async mounted() {
    // 从后台接口获取题库数据（会设置examId）；有缓存时会携带 examId 请求，返回 ID 与缓存不一致则重置缓存
    await this.fetchQuestionList();

    // 恢复考试数据（如果存在，需要examId）
    this.restoreExamData();

    // 恢复答案数据（需要examId）
    this.restoreAnswers();

    // 初始化当前题目的答案
    this.initCurrentAnswer();
    // 更新进度
    this.updateProgress();
    // 启动倒计时
    this.startCountdown();

    // 启动摄像头
    this.startCamera();

    // 监听页面刷新/关闭事件
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('beforeunload', this.handleBeforeUnload);

    // 已提交则移除缓存，未提交则保存考试数据
    if (this.examSubmitted) {
      localStorage.removeItem(this.getExamDataKey());
    } else {
      this.saveExamData();
    }

    // 停止摄像头
    this.stopCamera();

    // 清除倒计时定时器
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
      this.countdownTimer = null;
    }

    // 清除判卷倒计时定时器
    if (this.gradingTimer) {
      clearInterval(this.gradingTimer);
      this.gradingTimer = null;
    }

    // 清除性格测试完成定时器
    if (this.natureCompleteTimer) {
      clearInterval(this.natureCompleteTimer);
      this.natureCompleteTimer = null;
    }
  },
  watch: {
    examId(newExamId, oldExamId) {
      // 当examId改变时，重置倒计时和答案
      if (oldExamId !== null && newExamId !== null && newExamId !== oldExamId) {
        this.resetExamData();
      }
    },
    currentQuestionIndex() {
      // 当题目索引变化时，更新当前答案
      this.initCurrentAnswer();
      this.updateProgress();
    },
    currentAnswer() {
      // 当答案变化时，保存到题目数据中
      if (this.questionList[this.currentQuestionIndex]) {
        this.questionList[this.currentQuestionIndex].userAnswer = this.currentAnswer;
        this.updateProgress();
        // 自动保存到 localStorage
        this.saveExamData();
      }
    }
  },
  methods: {
    // 启动摄像头
    async startCamera() {
      try {
        // 检查浏览器是否支持getUserMedia
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          console.warn('浏览器不支持摄像头访问');
          this.$message.warning('您的浏览器不支持摄像头访问');
          return;
        }

        // 请求摄像头权限
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            width: { ideal: 640 },
            height: { ideal: 480 },
            facingMode: 'user' // 前置摄像头
          },
          audio: false // 不需要音频
        });

        // 保存视频流
        this.mediaStream = stream;
        this.cameraEnabled = true;

        // 将视频流绑定到video元素
        if (this.$refs.videoElement) {
          this.$refs.videoElement.srcObject = stream;
        }
      } catch (error) {
        console.error('启动摄像头失败:', error);
        this.cameraEnabled = false;

        // 根据错误类型显示不同的提示
        if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
          this.$message.error('摄像头权限被拒绝，请允许访问摄像头');
        } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
          this.$message.error('未检测到摄像头设备');
        } else {
          this.$message.error('启动摄像头失败：' + error.message);
        }
      }
    },
    // 停止摄像头
    stopCamera() {
      if (this.mediaStream) {
        // 停止所有轨道
        this.mediaStream.getTracks().forEach(track => {
          track.stop();
        });
        this.mediaStream = null;
      }

      // 清除video元素的srcObject
      if (this.$refs.videoElement) {
        this.$refs.videoElement.srcObject = null;
      }

      this.cameraEnabled = false;
    },
    // 获取localStorage的key（性格考试使用独立key，避免与普通考试缓存冲突）
    getExamDataKey() {
      const type = this.$route.params.type;
      return type === 'nature' ? 'exam_data_nature' : 'exam_data';
    },
    // 重置考试数据（当examId改变时调用）
    resetExamData() {
      // 清除旧的localStorage数据（如果有旧的examId）
      if (this.examId) {
        // 清除所有可能的旧数据
        const oldKeys = Object.keys(localStorage).filter(key => key.startsWith('exam_data_'));
        oldKeys.forEach(key => {
          if (key !== this.getExamDataKey()) {
            localStorage.removeItem(key);
          }
        });
      }

      // 重置倒计时
      this.remainingSeconds = 5400;
      this.examStartTime = Date.now();

      // 重置答案
      this.questionList.forEach(question => {
        if (question.type === 3) {
          question.userAnswer = [];
        } else {
          question.userAnswer = '';
        }
      });
      this.currentAnswer = '';
      this.currentQuestionIndex = 0;

      // 重置进度
      this.progressPercentage = 0;

      // 重新启动倒计时
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.startCountdown();

      // 初始化当前题目的答案
      this.initCurrentAnswer();
    },
    // 保存考试数据到 localStorage
    saveExamData() {
      if (this.examSubmitted) {
        return; // 已提交试卷，不再写入缓存
      }
      if (!this.examId) {
        return; // 如果还没有examId，不保存
      }

      try {
        const now = Date.now();
        const examData = {
          examId: this.examId,
          remainingSeconds: this.remainingSeconds,
          currentQuestionIndex: this.currentQuestionIndex,
          questionList: this.questionList.map(q => ({
            id: q.id,
            userAnswer: q.userAnswer
          })),
          examStartTime: this.examStartTime || now,
          lastSaveTime: now, // 用于恢复时按「距上次保存」计算剩余时间，避免误判超时
          examKey: this.examKey
        };
        localStorage.setItem(this.getExamDataKey(), JSON.stringify(examData));
      } catch (error) {
        console.error('保存考试数据失败:', error);
      }
    },
    // 恢复考试数据从 localStorage
    restoreExamData() {
      // 如果还没有examId，不恢复数据（等待fetchQuestionList获取examId）
      if (!this.examId) {
        this.examStartTime = Date.now();
        return;
      }

      try {
        const savedData = localStorage.getItem(this.getExamDataKey());
        if (savedData) {
          const examData = JSON.parse(savedData);

          // 检查examId是否匹配
          if (examData.examId !== this.examId) {
            // examId不匹配，清除旧数据，使用新数据
            this.examStartTime = Date.now();
            this.remainingSeconds = 5400;
            return;
          }

          // 用「上次保存时间」计算已过时间，避免用 examStartTime 导致旧会话/异常时间造成误判超时
          const now = Date.now();
          const lastSaveTime = examData.lastSaveTime || examData.examStartTime || now;
          const elapsedSeconds = Math.max(0, Math.floor((now - lastSaveTime) / 1000));
          const savedRemainingSeconds = examData.remainingSeconds || 5400;
          const actualRemainingSeconds = savedRemainingSeconds - elapsedSeconds;

          if (actualRemainingSeconds > 0) {
            this.remainingSeconds = actualRemainingSeconds;
            this.examStartTime = examData.examStartTime || now;
            this.examKey = examData.examKey || this.examKey;
            this.currentQuestionIndex = examData.currentQuestionIndex || 0;
          } else {
            // 恢复时不再设为 0 触发自动提交，只清除缓存并重置为 90 分钟；只有页面上倒计时归 0 才自动提交
            localStorage.removeItem(this.getExamDataKey());
            this.remainingSeconds = 5400;
            this.examStartTime = now;
          }
        } else {
          // 没有保存的数据，初始化新的考试
          this.examStartTime = Date.now();
        }
      } catch (error) {
        console.error('恢复考试数据失败:', error);
        // 恢复失败，使用默认值
        this.examStartTime = Date.now();
      }
    },
    // 恢复答案数据
    restoreAnswers() {
      if (!this.examId) {
        return; // 如果还没有examId，不恢复答案
      }

      try {
        const savedData = localStorage.getItem(this.getExamDataKey());
        if (savedData) {
          const examData = JSON.parse(savedData);

          // 检查examId是否匹配
          if (examData.examId !== this.examId) {
            return; // examId不匹配，不恢复答案
          }

          if (examData.questionList && Array.isArray(examData.questionList)) {
            // 将保存的答案恢复到题目列表中
            examData.questionList.forEach(savedQ => {
              const question = this.questionList.find(q => q.id === savedQ.id);
              if (question && savedQ.userAnswer !== undefined) {
                question.userAnswer = savedQ.userAnswer;
              }
            });
          }
        }
      } catch (error) {
        console.error('恢复答案数据失败:', error);
      }
    },
    // 处理页面刷新/关闭事件
    handleBeforeUnload(event) {
      // 保存当前答案
      if (this.questionList[this.currentQuestionIndex]) {
        this.questionList[this.currentQuestionIndex].userAnswer = this.currentAnswer;
      }
      // 保存考试数据
      this.saveExamData();

      // 显示提示信息
      const message = '刷新页面将不会保存答案，确定要离开吗？';
      event.returnValue = message;
      return message;
    },
    // 启动倒计时
    startCountdown() {
      // 清除已存在的定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      // 每秒更新一次倒计时
      this.countdownTimer = setInterval(() => {
        if (this.remainingSeconds > 0) {
          this.remainingSeconds--;
          this.updateCountdownDisplay();
        } else {
          // 倒计时结束，自动提交试卷
          this.handleTimeUp();
        }
      }, 1000);

      // 立即更新一次显示
      this.updateCountdownDisplay();
    },
    // 更新倒计时显示
    updateCountdownDisplay() {
      const hours = Math.floor(this.remainingSeconds / 3600);
      const minutes = Math.floor((this.remainingSeconds % 3600) / 60);
      const seconds = this.remainingSeconds % 60;

      if (hours > 0) {
        // 如果超过1小时，显示 HH:MM:SS
        this.countdown = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      } else {
        // 否则显示 MM:SS
        this.countdown = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }

      // 如果剩余时间少于5分钟，改变颜色提示
      if (this.remainingSeconds <= 300) {
        this.progressColor = '#f56c6c'; // 红色警告
      } else if (this.remainingSeconds <= 600) {
        this.progressColor = '#e6a23c'; // 橙色警告
      }

      // 定期保存倒计时数据（每10秒保存一次）
      if (this.remainingSeconds % 10 === 0) {
        this.saveExamData();
      }
    },
    // 倒计时结束处理
    handleTimeUp() {
      // 清除定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }

      // 保存当前答案
      if (this.questionList[this.currentQuestionIndex]) {
        this.questionList[this.currentQuestionIndex].userAnswer = this.currentAnswer;
      }

      // 清除保存的考试数据
      if (this.examId) {
        localStorage.removeItem(this.getExamDataKey());
      }

      // 提示时间到
      this.$alert('考试时间已到，系统将自动提交试卷！', '时间到', {
        confirmButtonText: '确定',
        type: 'warning',
        callback: () => {
          // 自动提交试卷
          this.submitExam();
        }
      });
    },
    // 提交试卷（内部方法，不显示确认框）
    async submitExam() {
      try {
        // 保存当前答案
        if (this.questionList[this.currentQuestionIndex]) {
          this.questionList[this.currentQuestionIndex].userAnswer = this.currentAnswer;
        }

        // 准备提交数据
        const submitData = this.questionList.map(question => {
          let userAnswer = question.userAnswer;

          // 处理多选题：将数组转换为字符串，如 ["B", "C"] => "B,C"
          if (question.type === 3 && Array.isArray(userAnswer)) {
            userAnswer = userAnswer.join(',');
          }

          // 如果答案为空，设置为空字符串
          if (userAnswer === undefined || userAnswer === null) {
            userAnswer = '';
          }

          return {
            id: question.id,
            userAnswer: String(userAnswer)
          };
        });

        // 调用提交接口
        this.loading = true;

        // 确保headers中包含token
        const token = getAccessToken();
        const headers = {};
        if (token) {
          headers.Authorization = 'Bearer ' + token;
        }

        const response = await request({
          url: '/system/exam-rocord/submit?rocordId=' + this.examId,
          method: 'POST',
          data: submitData,
          headers: headers
        });

        // 提交成功后清除缓存，并标记已提交（避免 beforeDestroy 再次写入缓存）
        this.examSubmitted = true;
        localStorage.removeItem(this.getExamDataKey());

        // 获取返回的recordId或examId
        const recordId = response?.data?.recordId || response?.recordId || response?.id;
        const examId = this.examId || response?.data?.examId || response?.examId;

        this.loading = false;
        // 获取type参数，判断是mock、性格考试还是正式考试
        const type = this.$route.params.type;
        if (type === 'nature') {
          // 性格测试：弹窗提示测试完成，3秒后跳转首页
          this.showNatureCompleteDialog();
          return;
        }
        const isFormal = type !== 'mock'; // 正式考试（mock跳转结果页）

        if (recordId || examId) {
          // 正式考试与模拟考试均先显示判卷中 10 秒，正式考后弹窗结果（无答题信息），模拟考后跳转结果页
          this.showGradingDialog(recordId, examId, isFormal);
        } else {
          this.$router.push('/index');
        }
      } catch (error) {
        console.error('提交试卷失败:', error);
        this.$message.error('提交试卷失败，请稍后重试');
        this.loading = false;
      }
    },
    // 从后台获取题库数据
    async fetchQuestionList() {
      try {
        this.loading = true;
        const type = this.$route.params.type;
        let apiUrl;
        let params = {};
        if (type === 'nature') {
          apiUrl = '/system/exam-rocord/nature';
        } else {
          apiUrl = type === 'mock' ? '/system/exam-rocord/mock' : '/system/exam-rocord/exam';
          params.category = '1';
        }

        // 若缓存中存在 exam_data，取出 examId 并在请求中携带
        let cachedExamId = null;
        const savedData = localStorage.getItem(this.getExamDataKey());
        if (savedData) {
          try {
            const examData = JSON.parse(savedData);
            if (examData && examData.examId != null) {
              cachedExamId = examData.examId;
            }
          } catch (e) {
            // 忽略解析失败
          }
        }
        if (cachedExamId != null) {
          params.examId = cachedExamId;
        }

        const response = await request({
          url: apiUrl,
          method: 'get',
          params
        });

        const responseExamId = response.id;
        // 若缓存的 examId 与接口返回的 ID 不一致，重置 exam_data 缓存
        if (cachedExamId != null && responseExamId !== cachedExamId) {
          localStorage.removeItem(this.getExamDataKey());
          // 新场次：重置考试状态
          this.remainingSeconds = 5400;
          this.examStartTime = Date.now();
          this.currentQuestionIndex = 0;
        }

        this.examId = responseExamId;

        // 处理返回的数据，转换为组件需要的格式
        if (response && Array.isArray(response.dataList)) {
          this.questionList = response.dataList.map(item => {
            let userAnswer = '';
            if (item.type === 3) {
              userAnswer = [];
            }
            return {
              id: item.id,
              title: item.title,
              content: item.content,
              answer: item.answer,
              type: item.type,
              freeType: item.freeType,
              userAnswer: userAnswer
            };
          });
          this.generateQuestionRows();
        }
      } catch (error) {
        console.error('获取题库数据失败:', error);
        // this.$message.error('获取题库数据失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    // 生成题目编号行
    generateQuestionRows() {
      const total = this.questionList.length;
      const rows = [];
      for (let i = 0; i < total; i += 5) {
        const row = [];
        for (let j = 0; j < 5 && i + j < total; j++) {
          row.push(i + j + 1);
        }
        rows.push(row);
      }
      this.questionRows = rows;
    },
    // 初始化当前题目的答案
    initCurrentAnswer() {
      if (this.questionList.length > 0) {
        const question = this.questionList[this.currentQuestionIndex] || this.questionList[0];
        if (question) {
          // 使用用户已保存的答案
          if (question.type === 3) {
            this.currentAnswer = Array.isArray(question.userAnswer)
              ? question.userAnswer
              : (question.userAnswer ? [question.userAnswer] : []);
          } else {
            this.currentAnswer = question.userAnswer || '';
          }
        }
      }
    },
    // 更新进度
    updateProgress() {
      const answeredCount = this.answeredQuestions.length;
      const total = this.questionList.length;
      if (total > 0) {
        this.progressPercentage = Math.round((answeredCount / total) * 100);
      }
    },
    handleQuestionClick(num) {
      // 保存当前答案
      if (this.questionList[this.currentQuestionIndex]) {
        this.questionList[this.currentQuestionIndex].userAnswer = this.currentAnswer;
      }
      this.currentQuestionIndex = num - 1;
      this.updateProgress();
    },
    handlePrevQuestion() {
      if (this.currentQuestionIndex > 0) {
        // 保存当前答案
        if (this.questionList[this.currentQuestionIndex]) {
          this.questionList[this.currentQuestionIndex].userAnswer = this.currentAnswer;
        }
        this.currentQuestionIndex--;
        this.updateProgress();
      }
    },
    handleNextQuestion() {
      if (this.currentQuestionIndex < this.questionList.length - 1) {
        // 保存当前答案
        if (this.questionList[this.currentQuestionIndex]) {
          this.questionList[this.currentQuestionIndex].userAnswer = this.currentAnswer;
        }
        this.currentQuestionIndex++;
        this.updateProgress();
      }
    },
    getQuestionTagType(questionNum) {
      if (this.answeredQuestions.includes(questionNum)) {
        return 'success';
      }
      if (this.currentQuestionIndex === questionNum - 1) {
        return 'primary';
      }
      return 'info';
    },
    handleSubmit() {
      // 清除倒计时定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }

      const unansweredCount = this.questionList.length - this.answeredQuestions.length;
      let message = '确定要提交试卷吗？提交后将无法修改答案。';
      if (unansweredCount > 0) {
        message += `\n\n还有 ${unansweredCount} 道题未作答，确定要提交吗？`;
      }

      this.$confirm(message, '提示', {
        confirmButtonText: '确定提交',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 提交试卷
        this.submitExam();
      }).catch(() => {
        // 取消提交，重新启动倒计时
        this.startCountdown();
      });
    },
    // 性格测试完成弹窗：提示测试完成，3秒后跳转首页
    showNatureCompleteDialog() {
      this.natureCompleteCountdown = 3;
      this.natureCompleteDialogVisible = true;
      if (this.natureCompleteTimer) {
        clearInterval(this.natureCompleteTimer);
      }
      this.natureCompleteTimer = setInterval(() => {
        this.natureCompleteCountdown--;
        if (this.natureCompleteCountdown <= 0) {
          clearInterval(this.natureCompleteTimer);
          this.natureCompleteTimer = null;
          this.natureCompleteDialogVisible = false;
          this.$router.push('/index');
        }
      }, 1000);
    },
    // 显示判卷中弹窗并开始倒计时；isFormal 为 true 时正式考试（10 秒后弹窗结果），为 false 时模拟考试（10 秒后跳转结果页）
    showGradingDialog(recordId, examId, isFormal) {
      this.gradingCountdown = 10;
      this.gradingDialogVisible = true;
      this.isFormalGrading = !!isFormal;

      if (this.gradingTimer) {
        clearInterval(this.gradingTimer);
      }

      this.gradingTimer = setInterval(() => {
        this.gradingCountdown--;
        if (this.gradingCountdown <= 0) {
          clearInterval(this.gradingTimer);
          this.gradingTimer = null;
          this.gradingDialogVisible = false;
          if (this.isFormalGrading) {
            this.fetchExamResultAndShow(recordId, examId);
          } else {
            const query = {};
            if (examId) query.examId = examId;
            if (recordId) query.recordId = recordId;
            this.$router.push({ name: 'result', query });
          }
        }
      }, 1000);
    },
    // 请求正式考试结果并弹窗展示（无答题详情）
    async fetchExamResultAndShow(recordId, examId) {
      try {
        const token = getAccessToken();
        const headers = token ? { Authorization: 'Bearer ' + token } : {};
        const response = await request({
          url: '/system/exam-rocord/examResult',
          method: 'GET',
          params: { examId: examId || undefined, recordId: recordId || undefined },
          headers
        });
        const data = response?.data ?? response;
        if (data) {
          this.resultDialogData = {
            jobTitle: data.jobTitle || 'UI工程师',
            score: data.score ?? 0,
            correctCount: data.correctCount ?? 0,
            totalCount: data.totalCount ?? 0,
            timeSpent: data.timeSpent || '0分钟'
          };
          this.resultDialogVisible = true;
        } else {
          this.$message.warning('未获取到答题结果');
          this.$router.push('/index');
        }
      } catch (err) {
        console.error('获取答题结果失败', err);
        this.$message.error('获取答题结果失败，请稍后重试');
        this.$router.push('/index');
      }
    },
    handleResultDialogClose() {
      this.resultDialogVisible = false;
    },
    handleBackToIndex() {
      this.resultDialogVisible = false;
      this.$router.push('/index');
    }
  }
};
</script>

<style scoped lang="scss" src="./assets/index.scss" />
